import { Component, OnInit, Injector, OnDestroy, ChangeDetectorRef, OnChanges, SimpleChanges, NgZone, ViewChild, ViewContainerRef, TemplateRef, ElementRef, AfterViewInit, Input } from '@angular/core';
import { Router, ActivationEnd, ActivatedRoute, UrlSegment, UrlSegmentGroup, NavigationStart, RouterEvent, NavigationEnd, NavigationCancel, NavigationError, GuardsCheckEnd } from '@angular/router';
import { IThirdNavCollapsibleElement } from "src/app/common-page-components/third-nav-tab-component/third-nav-tab-component.component";
import { filter, tap, map, mergeMap, first, distinctUntilChanged, catchError } from 'rxjs/operators';
import {
  AthleteBiographyStore,
  IAthleteBiography
} from "src/app/common-page-components/stores/entities-store/athlete-biography-store";
import { FiltersAthleteGeneralService } from '../../services/filters-athlete-general.service';
import { flatten } from 'src/app/officials/components/bootstrap-officials/bootstrap-officials.component';
import { of, combineLatest, Subscription, BehaviorSubject } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { NavigationEvent } from '@ng-bootstrap/ng-bootstrap/datepicker/datepicker-view-model';
import { state, style, transition, animate, trigger, query, animateChild } from '@angular/animations';
import { Location } from '@angular/common';
import { INews } from 'src/app/common-page-components/news-panel/news-panel.component';

/**
 * Components for introduce google ads script.
 *
 * @export
 * @class AngularEmbedScript
 * @implements {AfterViewInit}
 */
@Component({
    selector: 'angular-embed-script',
    template: '<div #script style.display="none"> \
        <ng-content></ng-content> \
        </div>'
})
export class AngularEmbedScript implements AfterViewInit {

    /**
     * Input src.
     *
     * @type {string}
     * @memberof AngularEmbedScript
     */
    @Input()
    src: string;

    /**
     * Type of script.
     *
     * @type {string}
     * @memberof AngularEmbedScript
     */
    @Input()
    type: string;

    /**
     * View child of element.
     *
     * @type {ElementRef}
     * @memberof AngularEmbedScript
     */
    @ViewChild('script', {static:true}) script: ElementRef;

    /**
     * Method for convert to script.
     *
     * @memberof AngularEmbedScript
     */
    convertToScript() {
        const element = this.script.nativeElement;
        const script = document.createElement("script");
        script.type = this.type ? this.type : "text/javascript";
        if (this.src) {
            script.src = this.src;
        }
        if (element.innerHTML) {
            script.innerHTML = element.innerHTML;
        }
        const parent = element.parentElement;
        parent.parentElement.replaceChild(script, parent);
    }

    /**
     * @{inheritdoc}
     *
     * @memberof AngularEmbedScript
     */
    ngAfterViewInit() {
        this.convertToScript();
    }
}

@Component({
  selector: "app-bootstrap-athlete",
  templateUrl: "./bootstrap-athlete.component.html",
  styleUrls: ["./bootstrap-athlete.component.scss"],
  animations: [
    trigger('fade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 })),
        query('@*', animateChild(), { optional: true }),

      ]),
      transition(':leave', [
        animate('500ms', style({ opacity: 0 })),
        query('@*', animateChild(), { optional: true }),
      ])
    ]),
    trigger('fadeInsight', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1000ms', style({ opacity: 1 })),
        query('@*', animateChild(), { optional: true }),

      ]),
      transition(':leave', [
        animate('2000ms', style({ opacity: 0 })),
        query('@*', animateChild(), { optional: true }),
      ])
    ]),
    trigger('navigate', [
      state('in', style({ 'opacity': '1' })),
      state('out', style({ 'opacity': '0' })),

      transition('* <=> *', [
        query('@*', animateChild(), { optional: true }),
        animate('1500ms')
      ])
    ]),
    trigger('heightAnimation', [
      transition(':enter', [
        query('@*', animateChild(), { optional: true }),
        style({ height: 0, paddingTop: 0, paddingRight: 0, paddingBottom: 0, paddingLeft: 0, opacity: 0 }),
        animate('1000ms', style({ height: '*', opacity: 1 }))
      ]),

      transition(':leave', [
        query('@*', animateChild(), { optional: true }),
        style({ height: '*', paddingTop: 0, paddingRight: 0, paddingBottom: 0, paddingLeft: 0, opacity: 1 }),
        animate('1000ms', style({ height: 0, paddingTop: 0, paddingRight: 0, paddingBottom: 0, paddingLeft: 0, opacity: 0 })),

      ]),

      transition('* <=> *', [
        query('@*', animateChild(), { optional: true }),
        animate('500ms')
      ]),

    ]),
  ],
})
export class BootstrapAthleteComponent implements OnDestroy {

  /**
   * The athlete saved.
   *
   * @type {IAthleteBiography}
   * @memberof BootstrapAthleteComponent
   */
  athlete: IAthleteBiography;

  /**
   * The model of biography.
   *
   * @type {AthleteBiographyStore}
   * @memberof BootstrapAthleteComponent
   */
  model: AthleteBiographyStore;

  /**
   * Indicates that navigation as been end and there aren't more redirections.
   *
   * @memberof BootstrapAthleteComponent
   */
  isNavigationEnd = true;

  /**
   * Subscription for destroy the router subscription in the end of component.
   *
   * @type {Subscription}
   * @memberof BootstrapAthleteComponent
   */
  subscription: Array<Subscription> = [];

  /**
   * A loading ref for show that submodules are loading.
   *
   * @memberof BootstrapAthleteComponent
   */
  loading = true;

  /**
   * A error ref for show that an error happens.
   *
   * @memberof BootstrapAthleteComponent
   */
  error = false;

  /**
   * A error message to be show when there's a fatal error on loading this page.
   *
   * @memberof BootstrapAthleteComponent
   */
  errorMessage = '';

  /**
   * Is navigating back property for animation.
   *
   * @memberof BootstrapAthleteComponent
   */
  isNavigatingBack=false;


  constructor(
    private router: Router,
    public common_service: FiltersAthleteGeneralService,
    private location: Location,
    private chg: ChangeDetectorRef,
  ) {
    this.model = common_service.athleteDetailStore;
    // Router for set the loading submodules.
    this.subscription.push(this.router.events.subscribe((e: RouterEvent) => {
      this.navigationInterceptor(e);
    }));
    // We call the service for set the athlete and the routing logic.
    this.subscription.push(this.common_service.cacheSubscription().pipe(
      distinctUntilChanged((f, s) => (f as any).Id === (s as any).Id),
      // Load was okay.
      map(next => {
        this.error = false;
        this.athlete = next as any;
        //this.chg.detectChanges();
        return this.athlete;
      }),
      catchError(e=> {
        this.athlete = undefined;
        // Set error and image if something happens.
        this.error = true;
        this.errorMessage = e.message;
        this.common_service.randomgImg.next(this.common_service.selectRandomImage());
        return of(e);
      }),
    ).subscribe()
    );
    this.subscription.push(this.location.subscribe((next) => {
      if (!next.url.includes(this.athlete.Id.toString())) {
            this.athlete = undefined;
            this.chg.detectChanges();
      }
    }) as any);
  }

  /**
   * Method for intercept the router event and set the loading.
   *
   * @param {RouterEvent} event
   * @memberof BootstrapAthleteComponent
   */
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.loading = true;
    }
    if (event instanceof NavigationEnd) {
      this.loading = false;

    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.loading = false;
    }
    if (event instanceof NavigationError) {
      this.loading = false;
    }
  }

  /**
   * Method for set the reuse of a route.
   *
   * @returns
   * @memberof BootstrapAthleteComponent
   */
  shouldReuse() {
    return this.athlete != undefined;
  }

  /**
   * {@inheritdoc}
   *
   * @memberof BootstrapAthleteComponent
   */
  ngOnDestroy() {
    this.subscription.forEach(value => value.unsubscribe());
  }



  /**
   * A method for obtain the athlete name
   *
   * @returns
   * @memberof BootstrapAthleteComponent
   */
  getAthleteName(athlete) {
    // tslint:disable-next-line:max-line-length
    return this.common_service.getAthleteName(athlete);
  }

  /**
   * A method for get the localized name of athlete is there's any.
   *
   * @param {IAthleteBiography} athlete
   * @returns
   * @memberof BootstrapAthleteComponent
   */
  getAthleteNameWithLocalize(athlete: IAthleteBiography) {
    if (athlete.GLocalizedName && athlete.FLocalizedName) {
      return athlete.WNameOrd === false
        ? athlete.GLocalizedName + " " + athlete.FLocalizedName
        : athlete.FLocalizedName +
        " " +
        athlete.GLocalizedName +
        " " +
        this.getAthleteName(athlete);
    } else {
      return this.getAthleteName(athlete);
    }
  }

  /**
   * Check if the person is an athlete and returns propertly string.
   *
   * @param {IAthleteBiography} athlete the athlete object.
   * @returns
   * @memberof BootstrapAthleteComponent
   */
  checkIfAthelte(athlete: IAthleteBiography) {
    return athlete && athlete.Stats ? (Object.keys(athlete.Stats).length > 0 ? 'Athlete' : '') : '';
  }
  /**
   * Check if the person is a coach and returns propertly string.
   *
   * @param {IAthleteBiography} athlete the athlete object.
   * @returns
   * @memberof BootstrapAthleteComponent
   */
  checkIfCoach(athlete: IAthleteBiography) {
    return flatten(Object.keys(athlete.Positions).map(key => (athlete.Positions[key])))
      .filter(value => value.FunName === 'Coach' || value.FunName.includes('Team') && value.FunYears.length > 0).length > 0 ? 'Coach' : '';
  }
  /**
   * Check if the person is an official and returns propertly string.
   *
   * @param {IAthleteBiography} athlete the athlete object.
   * @returns
   * @memberof BootstrapAthleteComponent
   */
  checkIfOfficial(athlete: IAthleteBiography) {
    return flatten(Object.keys(athlete.Positions).map(key => (athlete.Positions[key])))
      .filter(value => value.FunName !== 'Coach' && value.FunEnd !== "").length > 0 ? 'Official' : '';
  }

  /**
   * Method for render the propertly positions.
   *
   * @param {IAthleteBiography} athlete the biograpy athlete object.
   * @returns
   * @memberof BootstrapAthleteComponent
   */
  renderPositions(athlete: IAthleteBiography) {
    const isAthlete = this.checkIfAthelte(athlete);
    const isCoache = this.checkIfCoach(athlete);
    const isOfficial = this.checkIfOfficial(athlete);
    return `${isAthlete != '' || isOfficial != '' || isCoache != '' ? ' - ' : ''}` +
      isAthlete + `${isCoache !== '' ? ', ' : ''}` +
      isCoache + `${(isAthlete !== '' || isCoache !== '') && isOfficial !== '' ? ', ' : ''}` + isOfficial;
  }

}
